import { useCallback } from 'react';
import { useContext } from 'use-context-selector';
import { StickyControlContext } from '../contexts/internal/StickyContext.js';

/**
 * Legacy bucketplace/ui에서 필요한 것들만 따로 옮겨두었습니다.
 * 새로만든 Sticky를 기획전에 적용할 수 있으면 제거하면 됩니다.
 */
function useGetStickyHeight() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'top';
  var stickyControlContext = useContext(StickyControlContext);
  if (stickyControlContext == null) {
    throw new Error('StickyContext is not provided');
  }
  // TODO: This will be inaccurate if there are non-overlapping
  // sticky on the document. The difference will be minor if there aren't
  // too much of them, however, to correctly implement that, we basically have
  // to rewrite sticky emulation here. Because of this, I'm leaving this as-is,
  // yet, to allow future updates without breaking change, this accepts targetY
  // as the target position of the document. This can be implemented later,
  // and the upgrade path would be simple enough.
  return useCallback(function (targetY, filterEntry) {
    var _stickyControlContext = stickyControlContext.getState(),
      entries = _stickyControlContext.entries;
    var entryList = Object.keys(entries).map(function (key) {
      return entries[key];
    }).filter(function (entry) {
      if (entry.direction !== direction) {
        return false;
      }
      if (!entry.shouldInfluenceScroll) {
        return false;
      }
      if (filterEntry != null && !filterEntry(entry)) {
        return false;
      }
      return true;
    });
    var height = entryList.reduce(function (prev, entry) {
      if (entry.disabled) {
        return prev;
      }
      if (entry.beginY > targetY) {
        return prev;
      }
      var maxOffset = entry.offsetRange != null ? entry.offsetRange[1] : entry.offset;
      return prev + maxOffset + (entry.height || 0);
    }, 0);
    return height;
  }, [stickyControlContext, direction]);
}

export { useGetStickyHeight };
//# sourceMappingURL=useGetStickyHeight.js.map
